module.exports = __webpack_public_path__ + "static/media/clarity-landing.1a8cf4b6.png";